import ApplePayLogo from 'assets/icons/payment/apple-pay-logo.svg';
import cn from 'classnames';
import { useCart } from 'contexts/cart';
import useApplePayAvailability from 'hooks/common/use-apple-pay-availability';
import { useCartState } from 'modules/cart/state';
import React, { useCallback } from 'react';
import { MODAL_STATUS, useCartStore } from 'stores/carts';
import { showErrorToast } from 'utils/toasts';
import useApplePayButton from './state';

interface ApplePayButtonProps {
  className?: string;
}

const APPLE_PAY_SESSION_VERSION = 6;

const ApplePayButtonNew: React.FC<ApplePayButtonProps> = ({ className }) => {
  const { oosItems } = useCart();
  const { setModalOosStatus } = useCartStore();
  const isApplePayAvailable = useApplePayAvailability();
  const { effectiveCart } = useCartState();

  const { applePaySession, handleApplePayEvents, request } = useApplePayButton(effectiveCart);

  const onApplePay: React.MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      event.preventDefault();
      if (oosItems.length > 0) {
        setModalOosStatus(MODAL_STATUS.APPLEPAY_OPEN);
        return;
      }
      if (window.ApplePaySession && request) {
        try {
          applePaySession.current = new ApplePaySession(APPLE_PAY_SESSION_VERSION, request);

          handleApplePayEvents(applePaySession.current);

          applePaySession.current.begin();
        } catch (error) {
          console.error(error);
          showErrorToast({
            error: 'error:unknown',
            caller: 'ApplePayButton - Component',
          });
        }
      }
    },
    [oosItems.length, request, setModalOosStatus, applePaySession, handleApplePayEvents]
  );

  if (!isApplePayAvailable) return null;

  return (
    <button
      className={cn(
        'border-grey-200 flex w-full items-center justify-center rounded-full border',
        className
      )}
      onClick={onApplePay}
      data-test="apple-pay-button"
    >
      <ApplePayLogo />
    </button>
  );
};

export default ApplePayButtonNew;
